import React from "react";
import { Button, Typography } from "antd";
import { sbiDeclaration, bajajDeclaration } from "./declarationData";
const { Text } = Typography;

const Declaration = (props) => {
  const { partner, setShowModal } = props;

  return (
    <div
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.2)",
        position: "absolute",
        top: 0,
        width: "100%",
        height: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          position: "fixed",
          margin: "10px",
        }}
      ></div>
      <Button
            onClick={() => setShowModal(false)}
            style={{
              color: "#000000",
              fontSize: 12,
              top: "30%",
              right: "10px",
              position: 'absolute',
              borderWidth: 0,
              borderRadius: 50,
              width: 40,
            }}
          >
            X
          </Button>
      <div
        style={{
          overflowY: "scroll",
          backgroundColor: "#FFFFFF",
          position: "absolute",
          bottom: 0,
          width: "100%",
          height: "65%",
          borderTopLeftRadius: "20px",
          borderTopRightRadius: "20px",
          padding: 10,
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "row",
            marginTop: "30px",
            marginBottom: "10px",
          }}
        >
          Customer Declaration
        </div>
        <p>I hereby confirm and declare that:</p>
        <RenderDeclaration partner={partner} />
      </div>
    </div>
  );
};

const RenderDeclaration = ({ partner }) => {
  if (partner?.id === 207) {
    return (
      <ol>
        {sbiDeclaration.map((data, i) => {
          return <li key={i}>{data}</li>;
        })}
      </ol>
    );
  }
  return null;
};
export default Declaration;
